import userStore from '~/redux/user/store'
import {tveSignin} from '~/redux/user/actions'
import getQueryVariable from '~/tools/getQueryVariable'
import {get} from 'lodash'
import {flushAllProviders} from '~/redux/user/helpers'
import { trackEvent } from '~/tools/analytics/cleverTap'
import { initAuthZ } from './apis'


export const initializeRawInflate = () => {
	load().then(async () => {
    const aisresponse = getQueryVariable('aisresponse')
    const userState = userStore.getState().user || {};
		if(aisresponse && !userState.istveLoggedIn){
      const aisRes = JSON.parse(window.RawDeflate.inflate(atob(decodeURIComponent(aisresponse))));
      if(aisRes.authenticated){
        const mvpdProvider = Object.keys(aisRes.idps)[0];
        const providerName = mvpdProvider && aisRes.idps[mvpdProvider].display_name || null
        const logo = mvpdProvider && aisRes.idps[mvpdProvider].logos.full || ''
        const user = {
          "mvpdProvider": mvpdProvider,
          "provider": "verimatrix",
          "userId": userState && userState.userId || aisRes.aisuid,
          "tveUserId": aisRes.aisuid,
          "idpLogo": logo,
          "idpName": providerName,
          "resourceIdAccess":{}
        }
        trackEvent('TV login', {platform: 'Web', registrationType: 'Native'})
        const resourceIdStatus = await initAuthZ()
        resourceIdStatus && resourceIdStatus.forEach((item) => {
          user.resourceIdAccess[item.resource] = item.authorization
        })
        userStore.dispatch(tveSignin(user))
      }else{
        flushAllProviders()
      }
		}
	})
}

function load() {
	return new Promise(function(resolve, reject) {
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.async = true;
    script.src = get(window.settings, 'layoutUrlBase')+'assets/rawinflate.js';
		script.onload = resolve;
		script.onerror = reject;
		document.head.appendChild(script);
	})
}


